import { __awaiter, __generator, __read } from "tslib";
import * as React from 'react';
import { ApolloError } from 'apollo-boost';
import { useCreateRefundOrderMutation } from '@websky/graphql';
import PromoLoader from '@websky/core/src/PromoLoader';
import { isManualOperationError } from '../utils';
var CreateTicket = function (_a) {
    var params = _a.params, onCreate = _a.onCreate, onError = _a.onError;
    var _b = __read(useCreateRefundOrderMutation({ fetchPolicy: 'no-cache' }), 2), onCreateRefund = _b[0], loading = _b[1].loading;
    var onCreateRefundRequest = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, data, errors, e_1, errorMessage;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, onCreateRefund({
                            errorPolicy: 'all',
                            variables: { params: params }
                        })];
                case 1:
                    _a = _d.sent(), data = _a.data, errors = _a.errors;
                    if ((errors === null || errors === void 0 ? void 0 : errors.length) &&
                        !errors.some(function (error) {
                            var _a, _b, _c;
                            return isManualOperationError((_b = (_a = error['debugMessage']) !== null && _a !== void 0 ? _a : error['message']) !== null && _b !== void 0 ? _b : (_c = error.originalError) === null || _c === void 0 ? void 0 : _c['message']);
                        })) {
                        throw new ApolloError({ graphQLErrors: errors });
                    }
                    onCreate(data.CreateRefund);
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _d.sent();
                    errorMessage = 'Unknown error';
                    if (e_1 instanceof ApolloError && ((_c = (_b = e_1.graphQLErrors) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.message)) {
                        errorMessage = e_1.graphQLErrors[0].message;
                    }
                    else if (e_1 instanceof Error && e_1.message) {
                        errorMessage = e_1.message;
                    }
                    onError === null || onError === void 0 ? void 0 : onError(errorMessage);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [params, onCreateRefund, onCreate, onError]);
    React.useEffect(function () {
        onCreateRefundRequest();
    }, []);
    if (loading) {
        return React.createElement(PromoLoader, null);
    }
    return null;
};
export default CreateTicket;
